import { ITranslation } from "./types";

export const da: ITranslation = {
  messageFallbacks: {
    homeOrderNotReadyMsg:
      "Har du lige forladt butikken? Din kvittering er under behandling, så kig tilbage om lidt tid. I tilfælde af problemer kan du kontakte vores kundeservice.",
    errorReachOutSupportMsg:
      "I tilfælde af problemer kan du kontakte vores kundeservice.",
  },
  api: {
    E_FORCED_LOGOUT: "Du er logget ud, da din forbindelse er udløbet.",
  },
  orderStatus: {
    draft: "Kladde",
    contested: "Afventer",
    paid: "Betalt",
    unpaid: "Ikke betalt",
    pending: "Afventer",
    reviewed: "Rettet",
    paymentProcessing: "Betaling i gang",
    refunded: "Rembourseret",
    unknown: "Ukendt",
  },
  receiptsList: {
    headings: {
      date: "Dato",
      time: "Tidspunkt",
      status: "Status",
      total: "Total",
    },
    action: {
      view: "Vis",
    },
    statusTooltip: {
      draft: "Kladde - Købet behandles af systemet",
      paid: "Betalt - Købet er behandlet og betalt",
      paymentProcessing:
        "Betaling i gang - Købet er behandlet og betalingen undervejs",
      unpaid: "Ikke betalt - Købet er behandlet, men betalingen mislykkedes",
      pending: "Afventer - Vi behandler en indsigelse om købet",
      reviewed: "Rettet - Vi har rettet købet efter en indsigelse",
    },
    loadMore: "Indlæs mere",
    loadingMore: "Indlæser...",
    showing: "Viser",
  },
  receiptDetailScreen: {
    headerTitle: "Kvitteringsdetaljer",
    subtotal: "Subtotal",
    taxBreakdown: {
      headers: {
        rate: "Moms %",
        netto: "Netto",
        brutto: "Brutto",
        tax: "Moms",
        total: "Total:",
      },
    },
    tax: "Moms",
    taxCRV: "Pant",
    total: "Total",
    processTime: "Behandlingstid",
    date: "Dato",
    paymentStatus: "Status for betaling",
    orderId: "Ordre-ID",
    listOfProducts: "Varer",
  },
  receiptDetailComplain: {
    reportProblem: "Rapportér problem med kvitteringen",
    submitReview: "Send til gennemgang",
    confirmTitle: "Anmodning sendt",
    confirmButton: "Tilbage til kvitteringen",
    addMissingItem: "Tilføj manglende vare",
    addMissingItemMessage:
      "Skriv hvordan vi kan kontakte dig (email/telefon). Du kan også skrive evt. andre kommentarer.",
    form: {
      email: {
        label: 'Hvordan kan vi kontakte dig?',
        placeholder: 'Din e-mail, fx me@example.com',
        errors: {
          required: 'E-mailadresse er påkrævet.',
          isEmail: 'Ugyldig e-mailadresse.',
          inUse: 'E-mailadressen er allerede i brug.'
        }
      }
    }
  },
  receiptsScreen: {
    label: {
      contested: "INDSIGELSE",
      draft: "KLADDE",
      empty: "TOM",
      paid: "BETALT",
      pending: "KLADDE",
      refunded: "REFUNDERET",
      reviewed: "RETTET",
      unknown: "UKENDT",
      unpaid: "IKKE BETALT",
      paymentProcessing: "BETALING I GANG",
    },
    message: {
      contested: "Indsigelse besked",
      draft: "Kladde besked",
      empty: "Tom besked",
      paid: "Betalt besked",
      pending: "Afventer besked",
      refunded: "Refunderet besked",
      reviewed: "Rettet besked",
      unpaid: "Ikke betalt besked",
      paymentProcessing: "Betaling i gang besked",
    },
    minutes: "minutter",
    hours: "timer",
    days: "dage",
  },
  slideModal: {
    close: "Luk",
    searchPlaceholder: "Søg efter vare",
  },
  receiptsHome: {
    receiptPortal: "Digital kvittering",
    selectPaymentType: "Hvilket betalingsmiddel brugte du til dit køb?",
    cardBin: "Første %{cardBinDigitsCount} cifre af kortnummer",
    last4: "Sidste fire cifre af kortnummer",
    last4Apple: "Sidste fire cifre af Apple Pay-kortnummer",
    last4Google: "Sidste fire cifre af virtuelt kortnummer",
    instructionApple:
      "Find de sidste fire cifre af Apple Pay-kortnummeret i din Apple Wallet",
    openWallet: "Åbn Apple Wallet",
    instructionGoogle:
      "Find de sidste fire cifre af det virtuelle kortnummer i din Google Wallet",
    instructionExternalId:
      "Find nummer på betalingsreference i din betalings-app eller dit kontoudtog.",
    externalIdLabel: "Betalingsreference",
    externalIdPlaceholder: "",
    expDate: "Udløbsdato",
    visitDate: "Dato for køb",
    submit: "Hent kvittering(er)",
    registerEmail: "Skriv din email for at abonnere på fremtidige kvitteringer",
    registerEmailSuccess: "Email blev opdateret korrekt.",
    registerEmailFail:
      "Email blev ikke opdateret, da der ikke var nogen kvitteringer for indtastet betalingsmiddel og/eller købsdato.",
    unrecognizedError: "Der opstod en ukendt fejl",
    inconclusiveCardInfo: "Vi kan ikke finde din kvittering",
    optionalFieldPlaceholder: 'Valgfri',
    invalidCaptcha: "Verificering mislykkedes - prøv igen",
    oasisApiError:
      "Ingen forbindelse til kvitteringsserveren. Prøv igen senere.",
  },
};
